// extracted by mini-css-extract-plugin
export default {"information":"style_information__kAp2u","actions":"style_actions__D+nKz","label":"style_label__YB1Ev"};